import { io } from "socket.io-client";

// const urlApi = process.env.REACT_APP_API_URL_SOCKET;
// console.log("🔌 Conectando socket em:", urlApi);


export const socket = io('https://portal.cooperval.coop.br', {
    path: "/meu-socket",
    transports: ["polling", "websocket"],

});

// Monitorando eventos
socket.on("connect", () => {
    console.log("✅ Socket conectado com ID:", socket.id);
});

socket.on("disconnect", (reason) => {
    console.log("❌ Socket desconectado:", reason);
});

socket.on("connect_error", (error) => {
    console.error("⚠️ Erro de conexão no socket:", error);
});

socket.on("reconnect_attempt", (attempt) => {
    console.log("♻️ Tentativa de reconexão:", attempt);
});

socket.on("reconnect", (attempt) => {
    console.log("🔄 Reconectado após tentativas:", attempt);
});

socket.on("message", (data) => {
    console.log("📨 Mensagem recebida:", data);
});

// Opcional: monitorar envio
export function enviarMensagem(payload) {
    console.log("📤 Enviando mensagem:", payload);
    socket.emit("message", payload);
}
